export default __webpack_public_path__ + "static/media/Kia.3dc06dba.svg";